import React from 'react'

const Twenty_eight = () => {
    return (
        <div className='container'>
            <h1>Program to convert Decimal to Binary</h1>
           
           <p> Decimal to binary in C: We can convert any decimal number (base-10 (0 to 9)) into binary number(base-2 (0 or 1)) by c program.  <br />
            <br />
Decimal Number <br />
Decimal number is a base 10 number because it ranges from 0 to 9, there are total 10 digits between 0 to 9. Any combination of digits is decimal number such as 23, 445, 132, 0, 2 etc. <br />
<br />
Binary Number <br />
Binary number is a base 2 number because it is either 0 or 1. Any combination of 0 and 1 is binary number such as 1001, 101, 11111, 101010 etc. <br />
            </p>
            <h3>Decimal to Binary Conversion Algorithm</h3>
            <ol>
                <li>Step 1: Divide the number by 2 through % (modulus operator) and store the remainder in array</li>
                <li>Step 2: Divide the number by 2 through / (division operator)</li>
                <li>Step 3: Repeat the step 2 until number is greater than 0</li>
            </ol>
            <div className='containers'>
           <code className='library'> #include</code> &lt;stdio.h &gt;<br/>   
           <code className='library'>#include</code>&lt;stdlib.h &gt;<br/> 
           <code className='keywords'>int </code>main()&#123;<br/>  
           <code className='keywords'>int</code> a[10],n,i;<br/>    
system ("cls");<br/>  
<code className='library'>printf</code>("Enter the number to convert: ");<br/>    
<code className='library'>scanf</code>("%d",&n);<br/>    
<code className='keywords'>for</code>(i=0;n &gt;0;i++)    
&#123;<br/>    
a[i]=n%2;<br/>    
n=n/2;<br/>    
&#125;<br/>    
<code className='library'>printf</code>("\nBinary of Given Number is=");<br/>   
<code className='keywords'>for</code>(i=i-1;i&gt;=0;i--)    
&#123;<br/>
<code className='library'>printf</code>("%d",a[i]);<br/>    
&#125;<br/>    
<code className='library'>return</code> 0;<br/> 
&#125;<br/>
            </div>
        </div>
    )
}

export default Twenty_eight
